export const getGhostButton = (theme)=>({
        base: {
            color: theme.button.ghost.default,
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            '&:hover': {
                color: theme.button.ghost.hover
            },
            '&:active, &:focus:not(:focus-visible)': {
                color: theme.button.ghost.pressed,
                backgroundColor: 'transparent',
                outline: 'none'
            },
            '&:focus': {
                outline: `2.5px solid ${theme.button.focused.default}`,
                outlineOffset: 4,
                background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
                backgroundBlendMode: 'lighten'
            }
        },
        active: {},
        isLoading: {},
        disabled: {
            backgroundColor: 'transparent',
            border: 'none',
            color: theme.button.disabled.label,
            cursor: 'not-allowed',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: 'none'
            },
            '&:active, &:focus:not(:focus-visible)': {
                outline: 'none',
                boxShadow: 'none'
            },
            svg: {
                color: theme.button.ghost.disabled
            }
        }
    });

//# sourceMappingURL=ghost.js.map